import axiosClient from "../../../../system/helpers/axiosConfig";

export const getProgram = (params) => {
  return axiosClient
    .get(`api/admin/programs/edit`, { params })
    .then((r) => r.data);
};
